import { useEffect, useRef } from 'react';
import { useCookieConsent } from '@/context/CookieConsentContext.jsx';
import { configureTelemetry, trackTelemetry } from '@/lib/telemetryClient.js';
import { PUBLIC_TELEMETRY_EVENTS } from '@/lib/publicTelemetryContract.js';

export function useTelemetrySetup() {
  const { sessionId, categories } = useCookieConsent();
  const hasTrackedSessionRef = useRef(false);

  const hasAnalyticsConsent = Boolean(categories?.analytics);
  const hasMarketingConsent = Boolean(categories?.marketing);

  useEffect(() => {
    configureTelemetry({
      sessionId,
      hasAnalyticsConsent,
      hasMarketingConsent,
    });

    if (hasAnalyticsConsent && !hasTrackedSessionRef.current) {
      trackTelemetry(PUBLIC_TELEMETRY_EVENTS.CONSENT_GRANTED, {
        consent_analytics: true,
        consent_marketing: hasMarketingConsent,
      });
      hasTrackedSessionRef.current = true;
    }

    if (!hasAnalyticsConsent) {
      hasTrackedSessionRef.current = false;
    }
  }, [sessionId, hasAnalyticsConsent, hasMarketingConsent]);
}

export default useTelemetrySetup;
